import React from 'react';
import { Grid } from '@mui/material';
import { KEEP_STATIC_CODES_SAFE, THESE_ARE_YOUR_NEW_BACKUP_CODES, USE_BACKUP_CODES } from 'common/constants/login';
import BackupCodesInfo from './BackupCodesInfo';
import { PrintableBackupCodesProps } from './types';
import {
  CenterContainer,
  GridItem,
  HiddenGrid,
  Logo,
  ModalSubtitle,
  ModalSubtitleGrey,
  ModalTitle,
  PrintableContainer,
  PrintLogo,
  StyledPrintGrid,
} from '../BackupCodes.styles';

const PrintableBackupCodes = ({
  backupCodes,
  componentRef,
  disabledGenerate = false,
  forPrint,
  isGeneratingBackupCodes,
  isModal = false,
  username = '',
}: PrintableBackupCodesProps) => {
  const ContainerComponent = forPrint ? HiddenGrid : PrintableContainer;
  const GridComponent = forPrint ? StyledPrintGrid : CenterContainer;

  return (
    <ContainerComponent>
      <GridComponent ref={componentRef || undefined} container={!isModal}>
        {forPrint && (
          <PrintLogo>
            <Logo as="img" alt="Background" src="/images/logos/scalar-logo.jpg" />
          </PrintLogo>
        )}

        <GridItem item xs={12} lg={isModal ? 12 : 6} className={isModal ? 'modal' : 'regular'}>
          {isModal && (
            <ModalTitle variant="h6">
              {THESE_ARE_YOUR_NEW_BACKUP_CODES}
              {forPrint && ` for ${username}`}
            </ModalTitle>
          )}

          <ModalSubtitle>{KEEP_STATIC_CODES_SAFE}</ModalSubtitle>

          <ModalSubtitleGrey>{USE_BACKUP_CODES}</ModalSubtitleGrey>
        </GridItem>

        <Grid item xs={12} lg={isModal ? 12 : 6}>
          <BackupCodesInfo
            backupCodes={backupCodes}
            disabledGenerate={disabledGenerate}
            isGeneratingBackupCodes={isGeneratingBackupCodes}
            isModal={isModal}
          />
        </Grid>
      </GridComponent>
    </ContainerComponent>
  );
};

export default PrintableBackupCodes;
